import { Link } from "react-router-dom";
import LettuceLogo from "../../images/logo.png";

function NotFoundView() {
  return (
    <section className="relative isolate flex min-h-screen items-center justify-center overflow-hidden bg-[#FFF9E6] px-4 py-16 text-[#17210f] sm:px-6 lg:px-8">
      <div
        className="pointer-events-none absolute -left-24 top-16 h-64 w-64 rounded-full bg-[#F4F8EC] blur-2xl sm:h-80 sm:w-80"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -right-24 bottom-8 h-72 w-72 rounded-full bg-[#FFF1C7] blur-2xl sm:h-96 sm:w-96"
        aria-hidden="true"
      />

      <div className="relative w-full max-w-2xl rounded-[2rem] border border-[#E4EAD8] bg-white/90 px-6 py-10 text-center shadow-[0_18px_44px_rgba(78,67,24,0.1)] backdrop-blur-sm sm:px-12 sm:py-14">
        <div
          className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#F4F8EC] text-3xl text-[#307609] shadow-inner sm:h-20 sm:w-20 sm:text-4xl"
          aria-hidden="true"
        >
          <img src={LettuceLogo} alt="" className="h-12 w-12 object-contain sm:h-14 sm:w-14" />
        </div>

        <p className="mt-7 text-xs font-bold uppercase tracking-[0.22em] text-[#307609]">
          A small detour
        </p>
        <h1 className="mt-3 font-serif text-4xl font-bold leading-tight tracking-[-0.03em] text-[#082510] sm:text-5xl">
          This page isn’t available
        </h1>
        <p className="mx-auto mt-5 max-w-lg text-base font-medium leading-7 text-[#4d5749] sm:text-lg sm:leading-8">
          Let’s find a gentler place to begin. Create a conversation card or head back to the LettuceTalk home page.
        </p>

        <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
          <Link
            to="/refine"
            className="btn btn-primary h-auto min-h-12 rounded-full border-0 bg-[#307609] px-7 py-3 text-base font-bold text-white shadow-[0_12px_24px_rgba(48,118,9,0.22)] transition-colors hover:bg-[#245f07] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#307609]/30 motion-reduce:transition-none"
          >
            Create a gentle card
          </Link>
          <Link
            to="/"
            className="btn btn-ghost h-auto min-h-12 rounded-full px-7 py-3 text-base font-bold text-[#307609] underline-offset-4 hover:bg-[#F4F8EC] hover:underline focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#307609]/20 motion-reduce:transition-none"
          >
            Return home
          </Link>
        </div>
      </div>
    </section>
  );
}

export default NotFoundView;
